import { AbstractControl } from '@angular/forms';

export function jsonValidator(control: AbstractControl): { invalidJson: boolean } | null {
  const value = control.value;
  if (!value) { // empty allowed — change if needed
    return null;
  }

  try {
    JSON.parse(value);
    return null;
  } catch {
    return { invalidJson: true };
  }
}
